/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catalog_Movement_SquatInputs */

const en_us2_catalog_movement_squat = /** @type {(inputs: Catalog_Movement_SquatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`squat`)
};

const pt_br2_catalog_movement_squat = /** @type {(inputs: Catalog_Movement_SquatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`agachamento`)
};

const es_419_catalog_movement_squat = /** @type {(inputs: Catalog_Movement_SquatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sentadilla`)
};

const pt_pt2_catalog_movement_squat = /** @type {(inputs: Catalog_Movement_SquatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`agachamento`)
};

const fr_fr2_catalog_movement_squat = /** @type {(inputs: Catalog_Movement_SquatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`squat`)
};

const de_de2_catalog_movement_squat = /** @type {(inputs: Catalog_Movement_SquatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kniebeugen`)
};

const it_it2_catalog_movement_squat = /** @type {(inputs: Catalog_Movement_SquatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`squat`)
};

/**
* | output |
* | --- |
* | "squat" |
*
* @param {Catalog_Movement_SquatInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const catalog_movement_squat = /** @type {((inputs?: Catalog_Movement_SquatInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catalog_Movement_SquatInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_catalog_movement_squat(inputs)
	if (locale === "es-419") return es_419_catalog_movement_squat(inputs)
	if (locale === "pt-PT") return pt_pt2_catalog_movement_squat(inputs)
	if (locale === "fr-FR") return fr_fr2_catalog_movement_squat(inputs)
	if (locale === "de-DE") return de_de2_catalog_movement_squat(inputs)
	if (locale === "it-IT") return it_it2_catalog_movement_squat(inputs)
	return en_us2_catalog_movement_squat(inputs)
});
export { catalog_movement_squat as "catalog.movement.squat" }